import { type ReactNode, useEffect, useState } from 'react';
import { useLogto } from '@logto/react';
import { useAuth } from './useAuth';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useLogto();
  const { login } = useAuth();
  const [hasAuthenticatedOnce, setHasAuthenticatedOnce] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      setHasAuthenticatedOnce(true);
    }
  }, [isAuthenticated]);

  // Always redirect when session is lost — regardless of hasAuthenticatedOnce.
  // This fixes the "stuck on loading after tab return" case when the refresh token expires.
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login();
    }
  }, [isLoading, isAuthenticated, login]);

  // Show loading/redirect only before the first successful auth.
  // After that, keep children mounted even during silent token refresh to avoid
  // unmounting WorkspaceProvider and triggering an infinite re-load loop.
  if (!hasAuthenticatedOnce) {
    if (isLoading) {
      return (
        <div className="flex min-h-screen items-center justify-center">
          <div className="text-sm text-muted-foreground">Загрузка...</div>
        </div>
      );
    }
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-sm text-muted-foreground">Перенаправление на вход...</div>
      </div>
    );
  }

  return <>{children}</>;
}
